import React from "react";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";

// Components
import Container from "components/common/Layout/Container";
import Main from "components/common/Layout/Main";
import Doctors from "components/templates/search";

// Libs
import { appConfig, apiConfig } from "configs";
import Translation from "libs/Translation";

const DoctorProfilesBySpecialtyAndCity = ({
  doctors = {},
  citiesList = [],
  specialtiesList = [],
  educationLevelsList = [],
  faqList = [],
}) => {
  const router = useRouter();
  const { webConfig } = useSelector((state) => state.core);
  const { lang, name } = router.query;
  let params = {};
  let last = "";

  if (lang && lang !== "fa") {
    params = { ...params, lang };
  }
  Object.keys(params)?.forEach((k, index) => {
    last = `${last}${k}=${params[k]}`;
    if (index < Object.keys(params)?.length - 1) {
      last = `${last}&`;
    }
  });

  const breadCrumb = {
    itemListElements: [
      {
        position: 1,
        name: Translation.t("title.default"),
        item: "https://vclinic.io",
      },
      {
        position: 2,
        name: Translation.t("title.doctors"),
        item: `https://vclinic.io/explore/doctors`,
      },
    ],
  };

  let title = Translation.t("title.doctors-profile");
  let description = Translation.t("text.doctors-profile-desc");
  let lastBreadCrumb;

  const seo = {
    title: `${title} | ${Translation.t("title.default")}`,
    description,
    additionalMetaTags: [],
    canonical: last
      ? `${appConfig.site_url}/explore/doctors?${last}`
      : `${appConfig.site_url}/explore/doctors`,
  };

  return (
    <Main breadCrumb={breadCrumb} seo={seo}>
      <Container>
        <Doctors
          title={title}
          doctors={doctors?.list}
          doctorsCount={doctors?.total}
          cities={citiesList}
          specialties={specialtiesList}
          educationLevels={educationLevelsList}
          webConfig={webConfig}
          lastBreadCrumb={lastBreadCrumb}
          params={params}
          name={name}
          faqList={faqList}
          pageURL="/explore/doctors"
        />
      </Container>
    </Main>
  );
};

export default DoctorProfilesBySpecialtyAndCity;

export const getServerSideProps = async ({ query }) => {
  let result;
  let data;
  let notFound = false;

  // ... (Your existing variable setup for lang, page, etc.) ...
  let lang = "fa";
  let page = "1";
  if (query.lang) lang = query.lang;
  if (query.page) page = query.page;

  let queries = `?language=${lang}&page=${page}&limit=20&`;
  if (query.name) queries = `${queries}fullName=${query.name}&`;

  try {
    result = await Promise.all([
      fetch(
        `${appConfig.nest_api_base_url}${apiConfig.healthWorkers.endpoint}${queries}`
      ),
      fetch(`${appConfig.nest_api_base_url}${apiConfig.getCities.endpoint}`),
      fetch(
        `${appConfig.nest_api_base_url}${apiConfig.getSpecialties.endpoint}?lang=${lang}&SpecialtyType=SPECIALTY`
      ),
      fetch(
        `${appConfig.nest_api_base_url}${apiConfig.getSpecialties.endpoint}?lang=${lang}&SpecialtyType=EDUCATION_LEVEL`
      ),
      fetch(
        `${appConfig.node_api_base_url}${apiConfig.getFAQ.endpoint}?lang=${lang}&page=/search/[specialty]/[city]`
      ),
    ]);

    if (result) {
      data = await Promise.all([
        result[0].json(),
        result[1].json(),
        result[2].json(),
        result[3].json(),
        result[4].json(),
      ]);
    }
    // Safety check here: ensure data exists before checking status
    if (data && data[0]?.status === false) notFound = true;
  } catch (error) {
    console.error("API Fetch Error:", error);
  }

  // --- FIX IS BELOW ---
  // We change data[0] to data?.[0]
  return {
    props: {
      doctors: data?.[0]?.data ?? {},
      citiesList: data?.[1]?.data ?? [],
      specialtiesList: data?.[2]?.data ?? [],
      educationLevelsList: data?.[3]?.data ?? [],
      // Check if data[4] exists before accessing length
      faqList: data?.[4] && data[4].length ? data[4][0]?.FAQ : [],
    },
    notFound: notFound,
  };
};
